import { Component, OnInit } from '@angular/core';
import { ApiManagerService } from '@ildes/services/api-manager.service';
import { SessionStore } from '@ildes/stores/session.store';
import { AutoUnsubscribeComponent } from '@ildes/abstracts/auto-unsubscribe.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends AutoUnsubscribeComponent implements OnInit {

  user;

  constructor(
    private apiManager: ApiManagerService,
  ) {
    super();
  }

  ngOnInit(): void {
    const sub = SessionStore.getInstance().get$().subscribe((data) => {
        if (!data?.user) {

            return;
        }
        this.user = data?.user;
    });
    this.addSubscription(sub);
    this.apiManager.listProjects({expand: false}, { error: false, cache: true }) .subscribe(() => {}, () => {});
  }

}
